import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

const adminFieldService = {
  getRecurringTableConfig: async (user, tableFieldTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/template/field/recurring-table-config/${tableFieldTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  setRecurringTableConfig: async (user, tableFieldTemplateId, data) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/recurring-table-config/${tableFieldTemplateId}`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },
  deleteField: async (user, fieldTemplateId) => {
    return await axios.delete(
      `${NODE_BASE_URL}/admin/template/field/${fieldTemplateId}`,
      getAxiosOptions(user)
    )
  },
  deriveFieldsWithPages: async (user, activityTemplateId, data) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/derive-fields/${activityTemplateId}`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },
  importFieldsInBulk: async (user, activityTemplateId, data) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/import-fields/${activityTemplateId}`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },
  updateFieldSequenceInBulk: async (user, fields) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/update-sequence-bulk`,
        fields,
        getAxiosOptions(user)
      )
    ).data
  },
  updateSubfieldDefaultInBulk: async (user, fields) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/update-subfield-bulk`,
        fields,
        getAxiosOptions(user)
      )
    ).data
  },
  updateGridLayout: async (user, gridLayouts) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/update-grid-layout`,
        { gridLayouts },
        getAxiosOptions(user)
      )
    ).data
  },
}

export default adminFieldService
